export const getTwitterRestaurantReference = (twitterLink, whiteLabelName) => {
  if (twitterLink) {
    const matched = twitterLink.match(/twitter\.com\/@?([a-zA-Z0-9_]+)/)
    if (matched) return '@' + matched[1]
  }
  return whiteLabelName
}
